import { useMutation } from '@apollo/client';
import Loader from 'components/Loader';
import TextEditor from 'components/TextEditor';
import { UPDATE_POST_COMMENT } from 'containers/community/graphql/community.mutation';
import { isEmpty } from 'lodash';
import moment from 'moment';
import React from 'react';
import { Button, FormGroup, Label, Modal, ModalBody, ModalHeader } from 'reactstrap';

const UpdateCommentModal = ({ postId, selectedComment, updatedText = '', setUpdatedText, toggleModal }) => {
  const [updateUserCommentRequest, { loading: updateUserCommentsLoading }] = useMutation(UPDATE_POST_COMMENT, {
    onCompleted: () => {
      window.location.reload();
    },
    onError: (err) => {
      console.error('Error:', err);
    },
  });

  const handleSave = async () => {
    if (!isEmpty(selectedComment)) {
      toggleModal();
      await updateUserCommentRequest({
        variables: {
          postId,
          commentId: selectedComment?.id,
          createDTO: {
            content: updatedText,
            mediaId: -1,
          },
        },
      });
    }
  };

  return (
    <>
      <Loader isActive={updateUserCommentsLoading} />
      <Modal centered size="lg" isOpen={!isEmpty(selectedComment)}>
        <ModalHeader toggle={() => toggleModal()}>Update Comment</ModalHeader>
        <ModalBody className="p-4">
          <div className="mb-4">
            <h6 className="fw-500">
              Created by: <b>{selectedComment?.createdBy?.displayName}</b>
            </h6>
            <h6 className="fw-500">
              Created date: <b>{moment(selectedComment?.createdDate)?.format('DD-MMM-YYYY')}</b>
            </h6>
            <h6 className="mb-0 fw-500">
              Updated date: <b>{moment(selectedComment?.updatedDate)?.format('DD-MMM-YYYY')}</b>
            </h6>
          </div>

          <FormGroup>
            <Label>Content</Label>
            <TextEditor
              simple
              features={[['bold', 'underline', 'italic', 'list']]}
              height={200}
              initialValue={updatedText}
              onChange={(val) => setUpdatedText(val)}
            />
          </FormGroup>

          <div className="mt-4 mb-2">
            <Button color="primary" className="me-3" onClick={handleSave}>
              Save Comment
            </Button>
            <Button color="light" onClick={() => toggleModal()}>
              Cancel
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default UpdateCommentModal;
